import React from "react";
import ClimateDetails from "../../ClimateDetails";
import QuantityConfigurator from "../../QuantityConfigurator";
import { AddonProps } from "../type";

const HorizontalAddonCard = ({
    name,
    image,
    details,
    description = "",
    price,
    quantity,
    increment,
    decrement,
    isBasic = false,
    tags,
}) => {
    const configuratorConfig = {
        increment,
        decrement,
        quantity,
    };

    const isBase = tags && tags.some((tag) => tag.includes("basis"));
    const isDisabledClass = quantity <= 0 ? "disabled" : "";
    const isBaseClass = isBase ? "base" : "";
    const componentOptionalClasses = `${
        isBasic ? isDisabledClass : ""
    } ${isBaseClass}`;

    return (
        <div className={`hor-addon-card ${componentOptionalClasses}`}>
            <div className="img-container">
                <img
                    className="product-img"
                    src={image}
                    alt={name}
                    height="48"
                    width="48"
                />
                <span
                    className={`quantity-counter 
                    ${isBasic ? "" : isDisabledClass}`}
                >
                    {quantity}
                </span>
            </div>
            <div className="content">
                <span className="name">{name}</span>
                {details && (
                    <ClimateDetails
                        isSimple
                        climateDetails={details}
                        itemQuantity={quantity}
                    />
                )}
                {description && (
                    <span className="description">{description}</span>
                )}
                {price && <span className="price">{`+ ${price}`}</span>}
            </div>
            <QuantityConfigurator {...configuratorConfig} />
        </div>
    );
};

HorizontalAddonCard.propTypes = AddonProps;

export default HorizontalAddonCard;
